__webpack_require__.p = "/ynamly_vue/";